/*!
 * Copyright (c) Microsoft Corporation. All rights reserved.
 */

import { Form } from "formik";
import styled from "styled-components";

import {
  getTheme,
  FontSizes,
  FontWeights,
  IButtonStyles,
  ICommandBarStyles,
  IStackItemStyles,
  IStackStyles,
  IStackTokens,
} from "@fluentui/react";

const theme = getTheme();

export const ContentContainer = styled.div`
  background-color: ${theme.palette.white};
  box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.2);
  border-radius: 8px;
  padding: 24px;
`;

export const PageHeader = styled.div`
  background-color: ${theme.palette.white};
  display: flex;
  flex-direction: column;
  border-radius: 8px;
  padding: 24px;
  margin-top: 24px;
`;

export const PanelHeader = styled.h3`
  margin-bottom: 43px;
  font-weight: ${FontWeights.semibold};
  font-size: ${FontSizes.size32};
  line-height: 40px;
`;

export const PanelSubHeader = styled.p`
  font-weight: ${FontWeights.semibold};
  font-size: ${FontSizes.size24};
  line-height: 32px;
  margin-bottom: 24px;
`;

export const Subtitle = styled.p`
  font-weight: ${FontWeights.regular};
  font-size: ${FontSizes.size16};
  line-height: 22px;
  margin-bottom: 0;
`;

export const TextFieldContainer = styled.div`
  margin-bottom: 15px;
`;

export const Title = styled.h2`
  font-weight: ${FontWeights.semibold};
  font-size: ${FontSizes.size20};
  line-height: 28px;
`;

export const FlexWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
`;

export const StyledForm = styled(Form)`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;

  & input {
    height: 48px;
    font-size: 20px;
    line-height: 1.75rem;
  }
`;

export const verticalStackTokens: IStackTokens = { childrenGap: 20 };
export const horizontalStackTokens: IStackTokens = { childrenGap: 40 };

export const commandBarStyles: ICommandBarStyles = {
  root: {
    boxShadow: "0px 1px 4px rgba(0, 0, 0, 0.2)",
    borderRadius: "8px",
    padding: "18px",
    minHeight: "56px",
    marginBottom: "24px",
  },
};

export const fieldItemStyles: IStackItemStyles = {
  root: { height: "35px", width: "100%" },
};

export const flexStackStyles: IStackStyles = {
  root: {
    display: "flex",
    flexWrap: "wrap",
    marginBottom: "1.5rem",
  },
};

export const footerButtonStyles: IButtonStyles = {
  root: {
    marginRight: 8,
    width: "120px",
    height: "32px",
  },
};

export const formStackStyles: IStackStyles = {
  root: {
    margin: "0",
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
  },
};
